import { InternalAxiosRequestConfig } from "axios";

import { LOCAL_STORAGE } from "@constants";
import { User } from "@contexts/Auth";

export const tokenRequestInterceptor = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const userJSON = localStorage.getItem(LOCAL_STORAGE.USER);

  if (userJSON) {
    const { accessToken } = JSON.parse(userJSON) as User;

    if (accessToken) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      config.headers["token-corban"] = accessToken;
    }
  }

  return config;
};
